module.exports.AttachmentTypes = ['computer', 'trello', 'link', 'google-drive', 'dropbox', 'box', 'onedrive'];